// material-ui
import {
    Box,
    Paper,
    Table,
    TableBody,
    TableCell,
    TableContainer,
    TableHead,
    TablePagination,
    TableRow,
    Modal,
    Checkbox,
    Grid,
    ToggleButtonGroup,
    ToggleButton,
    Button,
    Typography,
    TextField,
    Select,
    MenuItem
} from '@mui/material';
import { ManageAccounts, Cancel } from '@mui/icons-material';
import { styled, useTheme } from '@mui/material/styles';
import { useState, useEffect } from 'react';
import { deepPurple, grey } from '@mui/material/colors';
import useFetchData from 'hooks/useFetchData';
import { axiosInstance } from 'utils/axios';
import { useSelector } from 'react-redux';
import { selectCurrentToken } from 'features/auth/authSlice';
import { successAlert, errorAlert, warningAlert } from 'ui-component/Toasts';

import { useTranslation } from "react-i18next";

const thirdPartyColumns = [
    { id: 'id', label: 'Count', minWidth: 30 },
    { id: 'name', label: 'Third Party Name', minWidth: 170 },
    { id: 'charges', label: 'Charges', minWidth: 170 },
];

const DailyCheckInTab = () => {
    const { t } = useTranslation();

    const token = useSelector(selectCurrentToken);

    const [bonusInputs, setBonusInputs] = useState({});
    const [updatedBonusAmountGiven, setUpdatedBonusAmountGiven] = useState(0);

    const handleBonusChange = (id, value) => {
        setBonusInputs(prev => ({ ...prev, [id]: value }));
    };

    const [programDetails, setProgramDetails] = useState([]);
    const fetchData = async () => {
        try {
            const res = await axiosInstance.get(`/DailyCheckInProgramDetails/All`, {
                headers: {
                    Authorization: `Bearer ${token}`
                }
            });
            if (res.status === 200) {
                setProgramDetails(res.data);
            }
        } catch (error) {

        }
    };

    const [updateButtonDisabled, setUpdateButtonDisabled] = useState(false);
    const submitUpdateProgram = async (id, newBonus) => {
        setUpdateButtonDisabled(true);

        try {
            const res = await axiosInstance.put(
                '/DailyCheckInProgramDetails',
                {
                    id: id,
                    bonusAmountGiven: newBonus
                },
                {
                    headers: {
                        Authorization: `Bearer ${token}`
                    }
                }
            );
            if (res.status === 200) {
                successAlert('成功更新会员等级');
                fetchData();
            } else {
                errorAlert('发生错误');
            }
        } catch (error) {
            console.log(error);
        } finally {
            setUpdateButtonDisabled(false);
        }
    };

    useEffect(() => {
        fetchData();
    }, []);

    return (
        <>
            <Paper sx={{ width: '100%', overflow: 'hidden', marginTop: '20px' }}>
                <TableContainer sx={{ height: '80vh' }}>
                    <Table stickyHeader aria-label="sticky table">
                        <TableHead>
                            <TableRow>
                                <TableCell key='dayNumber' style={{ width: 170 }}>{t("masterData.dayNumber")}</TableCell>
                                <TableCell key='bonusAmountGiven' style={{ width: 170 }}>{t("masterData.amount")}</TableCell>
                                <TableCell key='setting' style={{ width: 250 }}></TableCell>
                            </TableRow>
                        </TableHead>
                        <TableBody>
                            {programDetails.map((row) => {
                                return (
                                    <TableRow hover role="checkbox" tabIndex={-1} key={row.id}>
                                        <TableCell key='dayNumber' style={{fontSize: "12px"}}>
                                            {row.dayNumber}
                                            {row.updatedBy && <><br/>{t("masterData.by")}{row.updatedBy}{t("masterData.update")} <br/></>}
                                            {
                                                row.updatedDate && 
                                                <>
                                                    {t("masterData.updatedDate")}
                                                    {row.updatedDate.split('T')[0]} {new Date(
                                                        '1970-01-01T' + row.updatedDate.split('T')[1] + 'Z'
                                                    ).toLocaleTimeString('en-US', {
                                                        timeZone: 'UTC',
                                                        hour12: true,
                                                        hour: 'numeric',
                                                        minute: 'numeric',
                                                        second: 'numeric'
                                                    })}
                                                </>
                                            }
                                        </TableCell>
                                        <TableCell key='bonusAmountGiven' style={{fontSize: "12px"}}>
                                            {row.bonusAmountGiven}
                                        </TableCell>
                                        <TableCell key='setting' style={{fontSize: "12px"}}>
                                            <Box sx={{ alignItems: 'center', display: 'flex' }}>
                                                <TextField 
                                                    type="number"
                                                    id="outlined-basic" 
                                                    variant="outlined" 
                                                    value={bonusInputs[row.id] || ''}
                                                    onChange={(e) => handleBonusChange(row.id, e.target.value)}
                                                    style={{fontSize: '12px'}}
                                                />
                                                <Button
                                                    variant="contained"
                                                    sx={{
                                                        display: 'block',
                                                        mx: 'auto',
                                                        width: '150px',
                                                        backgroundColor: deepPurple[500]
                                                    }}
                                                    onClick={() => submitUpdateProgram(row.id, bonusInputs[row.id])}
                                                    disabled={updateButtonDisabled}
                                                >
                                                    {t("masterData.confirmUpdateAmount")}
                                                </Button>
                                            </Box>
                                        </TableCell>
                                    </TableRow>
                                );
                            })}
                        </TableBody>
                    </Table>
                </TableContainer>
            </Paper>
        </>
    );
};

export default DailyCheckInTab;